import React, { Fragment } from "react";
import PropTypes from "prop-types";
import moment from "moment";

const Signature = ({ data }) => {
  const completedOn = data["CompletedOn"] || {};
  const completedBy = data["CompletedBy"] || {};

  return (
    <Fragment>
      <p className="warning">
        <b>Note: Dependents aged 16 and above are required to sign</b>
      </p>
      <table>
        <tbody>
          <tr>
            <td>
              SIGNED IN SINGAPORE ON:{" "}
              {completedOn.fieldValue && moment(completedOn.fieldValue).format("DD MMM YY")}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <table className="signatures">
        <tbody>
          <tr>
            <td className="with-border">
              Name & Signature of Proposed Employee :{completedBy.fieldValue}
            </td>
            <td />
            <td className="with-border">Name & Signature of Dependent – Spouse:</td>
          </tr>
          <tr>
            <td />
            <td />
            <td className="with-border">Name & Signature of Dependent – Child 1:</td>
          </tr>
          <tr>
            <td />
            <td />
            <td className="with-border">Name & Signature of Dependent – Child 2:</td>
          </tr>
          <tr>
            <td />
            <td />
            <td className="with-border">Name & Signature of Dependent – Child 3:</td>
          </tr>
        </tbody>
      </table>
    </Fragment>
  );
};

Signature.propTypes = {
  data: PropTypes.object,
};

export default Signature;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Signature.jsx